function getSpinner() {
    return "<center><img class=\"loading-spinner\" width=\"64\" height=\"64\" src='\\Static\\img\\loading-waiting.gif' /></center>";
}